const FORM = {
  SUBMIT: 'Submit',
};

export { FORM };
